<ng-template #altCerts let-certId>
    @if (showAltCerts() && hasAlternativeCerts(certId)) {
        <span class="alt-certs-container">
            <em> (alts: @for (targetCert of getAllTargetCerts(certId); track targetCert.id; let isLastAlt = $last) {<span [ngClass]="getAltCertClass(targetCert)">{{targetCert.name}}</span>@if (!isLastAlt) {, }})</em>
        </span>
    }
</ng-template>

@if (certs?.length > 0) {
    @for (cert of certs; track cert; let isLast = $last) {
        @if (cert.changeType === changeType.Added && !cert.newValue?.isNA) {
            <span>
                <span class="job-qualifications-compare-change-added">{{cert.newValue.name}}{{cert.newValue.isPreferred ? '*' : ''}}</span>
                <ng-container *ngTemplateOutlet="altCerts; context: { $implicit: cert.newValue.id }"></ng-container>
                @if (!isLast) {
                    <span>, </span>
                }
            </span>
        }
        @if (cert.changeType === changeType.Removed && cert.originalValue !== null) {
            <span>
                <span class="job-qualifications-compare-change-removed">{{cert.originalValue?.name}}{{cert.originalValue?.isPreferred ? '*' : ''}}</span>
                <ng-container *ngTemplateOutlet="altCerts; context: { $implicit: cert.originalValue.id }"></ng-container>
                @if (!isLast) {
                    <span>, </span>
                }
            </span>
        }
        @if (cert.changeType === changeType.Changed && cert.originalValue !== null) {
            <span>
                <span class="job-qualifications-compare-change-removed">{{cert.originalValue?.name}}{{cert.originalValue?.isPreferred ? '*' : ''}}</span>&nbsp;<span class="job-qualifications-compare-change-added">{{cert.newValue?.name}}{{cert.newValue?.isPreferred ? '*' : ''}}</span>
                <ng-container *ngTemplateOutlet="altCerts; context: { $implicit: cert.newValue.id }"></ng-container>
                @if (!isLast) {
                    <span>, </span>
                }
            </span>
        }
        @if (cert.changeType === changeType.Unchanged && cert.originalValue && !cert.originalValue.isNA) {
            <span>
                <span>{{cert.originalValue.name}}{{cert.originalValue.isPreferred ? '*' : ''}}</span>
                <ng-container *ngTemplateOutlet="altCerts; context: { $implicit: cert.originalValue.id }"></ng-container>
                @if (!isLast) {
                    <span>, </span>
                }
            </span>
        }
    }
} @else {
    -
}